import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'

export const CLIENT_CONFIG = gql`
  query {
    clientConfig
  }
`

export async function fetchClientConfig(
  client: ApolloClient<unknown>,
): Promise<string> {
  const response = await client.query({
    query: CLIENT_CONFIG,
    fetchPolicy: 'no-cache',
  })
  return response.data.clientConfig
}
